import { useEffect, useState } from 'react';
import { loadResources } from '../utils/resources';

export function useLoadResources(): boolean {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    Promise.all(loadResources()).then(() => setLoaded(true));
  }, []);

  return loaded;
}
